import * as React from "react";
import { SVGProps } from "react";

const SearchSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.77 0C4.833 0 0 4.833 0 10.77c0 5.936 4.833 10.77 10.77 10.77 2.63 0 4.959-1.06 6.832-2.634l4.822 4.824a.923.923 0 0 0 1.306 0 .923.923 0 0 0 0-1.306l-4.824-4.822c1.574-1.873 2.633-4.202 2.633-6.832C21.54 4.833 16.706 0 10.77 0Zm0 1.846a8.909 8.909 0 0 1 8.921 8.924 8.89 8.89 0 0 1-2.601 6.3.923.923 0 0 0-.02 0 .923.923 0 0 0 0 .02 8.89 8.89 0 0 1-6.3 2.601 8.909 8.909 0 0 1-8.924-8.921 8.91 8.91 0 0 1 8.924-8.924z"
    />
  </svg>
);

export default SearchSVG;
